/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useRef, useState } from "react";
import "./EconomicsYear.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import FormBtn from "../../component/buttons/Form/FormBtn";
import NavigatePage from "../../component/header-navigate/NavigatePage";
import FooterDevOfficer from "../../component/footer/VillageDevelopmentOfficer/FooterDevOfficer";
import Village_Tal_Dist from "../../component/header-navigate/Village_Tal_Dist/Village_Tal_Dist";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import axios from "axios";
import {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
} from "../../Constant/Global";
import { ToastContainer, toast } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "../../assets/css/main.css";
import Loader from "../../component/Loader/Loader";
import { Button } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import { MdOutlineArrowDownward } from "react-icons/md";

const EconomicsYear_C = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [villageDataInfo, setVillageDataInfo] = useState("");
  const [yearInfo, setYearInfo] = useState("");
  const [isDraft, setIsDraft] = useState("");
  const currentDate = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(currentDate);
  const [srNo, setSrNo] = useState("");
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState(null);
  // किरकोळ मागणी  input filed calculation

  const [retailDemand1, setRetailDemand1] = useState("");
  const [retailDemand2, setRetailDemand2] = useState("");
  const [retailDemandSum, setRetailDemandSum] = useState("");

  const userDataInfo = sessionStorage.getItem("info");
  const userData = JSON.parse(userDataInfo);
  const userDetails = userData.user_details;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const retailDemandCalculation = () => {
    const retailDemand1Num = parseFloat(retailDemand1) || 0;
    const retailDemand2Num = parseFloat(retailDemand2) || 0;

    if (isNaN(retailDemand1Num) || isNaN(retailDemand2Num)) {
      setRetailDemandSum("");
    } else {
      const sum = retailDemand1Num + retailDemand2Num;
      setRetailDemandSum(Math.round(sum));
    }

    // const sum = parseInt(retailDemand1) + parseInt(retailDemand2);
    // setRetailDemandSum(sum);
  };

  useEffect(() => {
    retailDemandCalculation();
  }, [retailDemand1, retailDemand2]);

  const handleEconocmic = async () => {
    const finalData = {
      gram_sevek_id: userDetails.id,
      village_id: userDetails.village_id,
      taluka_id: userDetails.taluka_id,
      district_id: userDetails.district_id,
      year_id: userDetails.current_year_id,
    };
    try {
      const response = await axios.post(
        API_BASE_URL + "api/economic_c",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      setIsLoading(false);
      console.log("economic_c data", response.data.data);
      setVillageDataInfo(response.data.data.other_data);
      console.log("village data information", response.data.data.other_data);
      setYearInfo(response.data.data.year_info);
      setDate(response.data.data.economic_c_data.date);
      setSrNo(response.data.data.economic_c_data.sr_no);
      setData(response.data.data.economic_c_data);
      setRetailDemand1(response.data.data.economic_c_data.past_due);
      setRetailDemand2(response.data.data.economic_c_data.current_demand);
      if (
        response.data.data.economic_c_data === null ||
        response.data.data.economic_c_data.length === 0
      ) {
        setIsDraft("");
      } else {
        setIsDraft(response.data.data.economic_c_data.is_draft);
      }
    } catch (error) {
      console.log("error occured store data on server", error);
    }
  };

  useEffect(() => {
    handleEconocmic();
  }, []);

  const handleDataRefresh = async () => {
    await handleEconocmic();
  };

  // Reset the data of the server with condiotion wise.
  const handleDataRefreshReset = async () => {
    if (data !== null && typeof data === "object") {
      await handleEconocmic();
    } else {
      setRetailDemand1("");
      setRetailDemand2("");
      setValidated(false);
    }
  };
  // Refs for input elements
  const retailDemand1Ref = useRef(null);
  const retailDemand2Ref = useRef(null);
  const srNoRef = useRef(null);
  useEffect(() => {
    // Set focus on the first input with an error
    if (validated) {
      if (!isNumeric(retailDemand1)) {
        retailDemand1Ref.current.focus();
      } else if (!isNumeric(retailDemand2)) {
        retailDemand2Ref.current.focus();
      } else if (!isNumeric(srNo)) {
        srNoRef.current.focus();
      }
      // ... (add similar conditions for other inputs)
    }
  }, [validated]);

  // Validation functions
  const isNumeric = (value) => {
    return /^-?\d*\.?\d+$/.test(value);
  };

  const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;

  const formatDateString = (inputDate) => {
    const [day = "", month = "", year = ""] = inputDate.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  const formatted = formatDateString(date);

    // check validation when before update the data .
    const validateForm = () => {
      // Validation logic based on your requirements
      if (
        !isNumeric(retailDemand1) ||
        !isNumeric(retailDemand2) ||
        !isNumeric(srNo) ||
        !dateRegex.test(formatted)
      ) {
        setValidated(true);
        // Additional actions if needed
        // ...
        return true; // Validation failed
      }
      return false; // Validation passed
    };
    
    // check is validated or not.
    const handleFormSubmission = async (e) => {
      e.preventDefault();
    
      const isValid = validateForm();
      if (isValid) {
        if(validated){
          await handleUpdateEconomic(e);
        }
      }else{
        handleShow();
      }
    }
   
  // scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Optional smooth scrolling
    });
  };

  //  update data in api
  const handleUpdateEconomic = async (e) => {
    
    e.preventDefault();
    const isValid = validateForm();
    if (isValid) {
      setValidated(true);
      scrollToTop();
      return;
    }
    
    handleClose();

    const finalData = {
      year_id: userDetails.current_year_id,
      gram_sevek_id: userDetails.id,
      village_id: userDetails.village_id,
      taluka_id: userDetails.taluka_id,
      district_id: userDetails.district_id,
      date: date,
      sr_no: srNo,
      economic_c_data: {
        past_due: retailDemand1,
        current_demand: retailDemand2,
        toal_demand: retailDemandSum,
      },
    };
    try {
      const response = await axios.post(
        API_BASE_URL + "api/update_economic_c",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      if (response.data.status === true) {
        toast.success(response.data.message);
        setValidated(false);
        setTimeout(() => {
          handleDataRefresh();
        }, 2000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("error occured updata data", error);
    }
  };

  // store data in draft
  const handleStoreEconomic = async (e) => {
    const formattedDate = formatDateString(date);
    e.preventDefault();
    if (
      (!isNumeric(retailDemand1) && retailDemand1 !== "") ||
      (!isNumeric(retailDemand2) && retailDemand2 !== "") ||
      (!isNumeric(srNo) && srNo !== "") ||
      (!dateRegex.test(formattedDate) && date !== "")
    ) {
      setValidated(true);
      return;
    }
    const finalData = {
      year_id: userDetails.current_year_id,
      gram_sevek_id: userDetails.id,
      village_id: userDetails.village_id,
      taluka_id: userDetails.taluka_id,
      district_id: userDetails.district_id,
      date: date,
      sr_no: srNo,
      economic_c_data: {
        past_due: retailDemand1,
        current_demand: retailDemand2,
        toal_demand: retailDemandSum,
      },
    };
    try {
      const response = await axios.post(
        API_BASE_URL + "api/draft_economic_c",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      toast.success(response.data.message);
      setValidated(false);
      setTimeout(() => {
        handleDataRefresh();
      }, 2000);
    } catch (error) {
      toast.error(error);
    }
  };

  const inputWidth = {
    width: `${(srNo?.length + 1 || 5) * 12}px`, // Adjust the multiplier based on your needs
  };

  const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>किरकोळ मागणी (पवनचक्की सोडून)</title>
      </Helmet>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="container common-section pt-0">
          <div className="row">
            <div className="col-lg-12 navigate-section-header mt-3">
              <div className="page-title">
                <p className="fw-bold mb-2">१.१ आर्थिक वर्ष मागणी</p>
              </div>
              <div className="navigate-section d-flex">
                <div className="arrow-box">
                  <Link to="/eco-a" className="me-5 text-dark">
                    अ) ग्रामपंचायत करमागणी ( घरपट्टी )
                  </Link>
                </div>
                <div className="arrow-box">
                  <Link to="/eco-b" className="me-5 text-dark">
                    ब) पाणीपट्टी
                  </Link>
                </div>
                <div className="arrow-box-active d-flex flex-column justify-content-center">
                  <Link to="/eco-c" className="text-decoration-none">
                    क) किरकोळ मागणी
                  </Link>
                  <span className="text-center arrow-icon">
                    <ArrowDropDownIcon fontSize="large" color="primary" />
                  </span>
                </div>
                <div className="arrow-box">
                  <Link to="/eco-d" className="ms-5 text-dark">
                    ड) पवनचक्की / कारखाना मागणी
                  </Link>
                </div>
                <div className="arrow-box me-3">
                  <Link to="/eco-e" className="ms-5 text-dark">
                    इ) खर्च तरतूद
                  </Link>
                </div>
              </div>
              {/* <TabEco/> */}
            </div>
            <div className="col-lg-12 mt-5 mb-5">
              <Village_Tal_Dist
                villageDataInfo={villageDataInfo}
                yearInfo={yearInfo}
              />
            </div>
            <div className="col-lg-12">
              <div className="table-main-sec">
                <p>
                  क) किरकोळ मागणी (पवनचक्की सोडून){" "}
                  {isDraft === "Y" ? (
                    <span className="fw-bold text-danger">is Drafted</span>
                  ) : isDraft === "N" ? (
                    <span className="submit_text">
                      Submitted{" "}
                      <img
                        src={require("../../component/assets/images/sumbit-success.png")}
                        alt="success"
                        width={30}
                        className="img-fluid"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </p>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">
                          मागील थकबाकी <br /> (सन{" "}
                          {yearInfo ? yearInfo.previous_year_name : ""})
                        </th>
                        <th scope="col">
                          चालू मागणी <br /> (सन{" "}
                          {yearInfo ? yearInfo.current_year_name : ""})
                        </th>
                        <th scope="col">
                          एकूण मागणी <br />
                          (मागील + चालू) (सन{" "}
                          {yearInfo ? yearInfo.current_year_name : ""})
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input
                            type="text"
                            value={retailDemand1}
                            onChange={(e) => setRetailDemand1(e.target.value)}
                            onKeyDown={(evt) =>
                              ["e", "E", "+", "-", "*"].includes(evt.key) &&
                              evt.preventDefault()
                            }
                            placeholder={
                              validated && !isNumeric(retailDemand1)
                                ? "कृपया वैध क्रमांक प्रविष्ट करा."
                                : ""
                            }
                            className={`form-control table-input-box ${
                              validated && !isNumeric(retailDemand1)
                                ? "is-invalid"
                                : ""
                            }`}
                            ref={retailDemand1Ref}
                            autoFocus
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={retailDemand2}
                            onChange={(e) => setRetailDemand2(e.target.value)}
                            onKeyDown={(evt) =>
                              ["e", "E", "+", "-", "*"].includes(evt.key) &&
                              evt.preventDefault()
                            }
                            placeholder={
                              validated && !isNumeric(retailDemand2)
                                ? "कृपया वैध क्रमांक प्रविष्ट करा."
                                : ""
                            }
                            className={`form-control table-input-box ${
                              validated && !isNumeric(retailDemand2)
                                ? "is-invalid"
                                : ""
                            }`}
                            ref={retailDemand2Ref}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={retailDemandSum}
                            readOnly
                            className="form-control table-input-box fw-bold"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="mt-3">
                  वरील प्रमाणे ग्रामपंचायतची करमागणी ग्रामपंचायतची दिनांक -{" "}
                  <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className={`date_input ${validated ? "" : "is-invalid"}`}
                    placeholder="dd-mm-yy"
                    max={getCurrentDate()}
                  />{" "}
                  रोजीच्या मासिक सभेत ठराव क्र.
                  <input
                    type="text"
                    value={srNo}
                    onChange={(e) => setSrNo(e.target.value)}
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-", "*"].includes(evt.key) &&
                      evt.preventDefault()
                    }
                    placeholder={
                      validated && !isNumeric(srNo) ? "क्रमांक टाका." : ""
                    }
                    className={`sr_no_input ${
                      validated && !isNumeric(srNo) ? "is-invalid" : ""
                    }`}
                    ref={srNoRef}
                    style={inputWidth}
                  />{" "}
                  ने कायम झाला.
                </p>
                {validated && !date ? (
                  <span className="text-danger">दिनांक निवडा.</span>
                ) : validated && !dateRegex.test(formatted) ? (
                  <span className="text-danger">
                    अयोग्य दिनांक फॉर्मॅट (dd-mm-yyyy).
                  </span>
                ) : (
                  ""
                )}
                {validated && !isNumeric(srNo) ? (
                  <span className="text-danger">ठराव क्रमांक टाका.</span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-lg-12">
              <FooterDevOfficer villageDataInfo={villageDataInfo} />
            </div>
            <div className="col-lg-12 d-flex mt-4 justify-content-end align-items=center">
              {(isDraft === "" || isDraft === "Y") && (
                <FormBtn
                  resetForm={handleDataRefreshReset}
                  handleSubmit={handleFormSubmission}
                  handleDraft={handleStoreEconomic}
                />
              )}
            </div>
            {isDraft === "N" && (
              <div className="col-lg-12">
                <div className="d-flex justify-content-between">
                  <p className="text-danger">
                    सूचना : कृपया काही बदल करायचा असेल तर बी. डी. ओ. ला विनंती
                    करा.{" "}
                  </p>
                  <div>
                    <Button variant="contained">विनंती करा</Button>
                  </div>
                </div>
              </div>
            )}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {" "}
                    सूचना <MdOutlineArrowDownward />
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Submit केल्यानंतर तुम्ही बी.डी.ओ. च्या मंजुरीशिवाय फॉर्म Edit
                  करू शकत नाही. कृपया खात्री करा की तुम्ही फॉर्म Submit करू
                  इच्छिता?
                </Modal.Body>
                <Modal.Footer className="gap-3">
                  <Button className="modal-button-cancel" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    className="modal-button-submit"
                    onClick={handleUpdateEconomic}
                  >
                    Submit
                  </Button>
                </Modal.Footer>
              </Modal>
          </div>
          <ToastContainer
            position={"top-center"}
            autoClose={2000}
            pauseOnHover={false}
            closeOnClick={true}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default EconomicsYear_C;
